import { render, staticRenderFns } from "./SuccessSignUp.vue?vue&type=template&id=1c33063c&"
import script from "./SuccessSignUp.vue?vue&type=script&lang=js&"
export * from "./SuccessSignUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports